import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

export interface DescriptionModalData {
  title?: string;
  text: string;
}

@Component({
  selector: 'app-description-modal',
  templateUrl: './description-modal.component.html',
  styleUrls: ['./description-modal.component.css']
})
export class DescriptionModalComponent {
  copied = false;

  constructor(
    public dialogRef: MatDialogRef<DescriptionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DescriptionModalData,
    @Optional() private snackBar?: MatSnackBar,
    @Optional() private translate?: TranslateService
  ) {}

  get currentLang(): string {
    return localStorage.getItem('lang') || 'en-US';
  }

  get title(): string {
    const raw = this.data?.title;
    if (raw) {
      if (this.translate) {
        const tr = this.translate.instant(raw);
        if (tr && tr !== raw && !tr.startsWith('common.') && !tr.startsWith('workOrder.')) return tr;
      }
      return raw;
    }
    const dict: Record<string, string> = {
      'en-US': 'Work Description',
      'hi-IN': 'वर्क डिस्क्रिप्शन',
      'mr-IN': 'वर्क डिस्क्रिप्शन',
      'bn-IN': 'ওয়ার্ক ডেসক্রিপশন'
    };
    return dict[this.currentLang] || 'Work Description';
  }

  get text(): string {
    return this.data?.text || '';
  }

  get closeText(): string {
    if (this.translate) {
      const val = this.translate.instant('common.close');
      if (val && val !== 'common.close') return val;
    }
    const dict: Record<string, string> = {
      'en-US': 'Close',
      'hi-IN': 'क्लोज',
      'mr-IN': 'क्लोज',
      'bn-IN': 'ক্লোজ'
    };
    return dict[this.currentLang] || 'Close';
  }

  get copiedText(): string {
    if (this.translate) {
      const val = this.translate.instant('common.copiedToClipboard');
      if (val && val !== 'common.copiedToClipboard') return val;
    }
    const dict: Record<string, string> = {
      'en-US': 'Copied to clipboard',
      'hi-IN': 'कॉपीड टू क्लिपबोर्ड',
      'mr-IN': 'कॉपीड टू क्लिपबोर्ड',
      'bn-IN': 'কপিড টু ক্লিপবোর্ড'
    };
    return dict[this.currentLang] || 'Copied to clipboard';
  }

  copyToClipboard(): void {
    if (!this.text) return;
    navigator.clipboard.writeText(this.text).then(() => {
      this.copied = true;
      if (this.snackBar) {
        this.snackBar.open(this.copiedText, '', {
          duration: 2000,
          panelClass: ['success-snackbar']
        });
      }
      setTimeout(() => {
        this.copied = false;
      }, 2500);
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
